import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "user-owner"
}
const _hoisted_2 = { class: "market-list-item__product-img" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "market-list-item__content" }
const _hoisted_6 = { class: "user-content" }
const _hoisted_7 = {
  key: 0,
  class: "bp-icon-Verified verified"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "listing-content" }
const _hoisted_10 = { class: "field-label" }
const _hoisted_11 = { class: "field-value" }

import { ref, onMounted, onBeforeUnmount } from "vue";
import { useRouter } from 'vue-router';
import ImageSwiperComponent from '@/components/common/ImageSwiperComponent/ImageSwiperComponent.vue';
import {MarketListItem} from "@/models/frontend/MarketModels";
import { getPalletImage } from "@/helpers/PalletImageHelper";
import NoFoto from "@/assets/images/default_images/No-foto.png";
import ModalComponent from "@/components/core/ModalComponent/ModalComponent.vue";
import UserInfo from "@/components/screens/User/UserInfoComponent.vue";
import { getStars } from "@/helpers/RatingHelper";

// eslint-disable-next-line no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'MarketListItemComponent',
  props: {
    item: {},
    userId: {}
  },
  setup(__props: any) {

const props = __props;
const isActive = ref(false);
const listElement = ref<HTMLElement | null>(null);
const isWide = ref(false);
const router = useRouter();
const showUserModal = ref(false);

const checkWidth = () => {
  if (listElement.value) {
    const elementWidth = listElement.value.offsetWidth; 
    isWide.value = elementWidth > 1024; 
  }
};

const goTo = (id: string, event: Event) => {
  const path = event.composedPath();

  if (path.some(el => el instanceof HTMLElement && el.classList.contains('swiper')) || path.some(el => el instanceof HTMLElement && el.classList.contains('name'))) {
    return;
  } else {
    isActive.value = true;
    router.push(`/listing/${id}`);
  }
};

const openUserModal = (e: Event) => {
  e.preventDefault();
  e.stopPropagation();
  showUserModal.value = true;
};

onMounted(() => {
  checkWidth();
  window.addEventListener("resize", checkWidth);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkWidth);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "listElement",
    ref: listElement,
    class: _normalizeClass(['market-list-item', { /* active: isActive,*/ wide: isWide.value, buyer:_ctx.item.type=='buyer'}]),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (goTo(_ctx.item.id, $event)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['header',  (_ctx.item.type == 'seller')?'sale-header':(_ctx.item.type == 'buyer')?'offer-header':'',{ 'with-owner': _ctx.item.userId==props.userId}])
    }, [
      (_ctx.item.userId==props.userId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[3] || (_cache[3] = [
            _createElementVNode("i", null, "!", -1),
            _createElementVNode("span", null, "Este anuncio es tuyo", -1)
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, "anuncio de " + _toDisplayString((_ctx.item.type == 'buyer')?'compra':'venta'), 1)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.item.type == 'buyer')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "product-img",
            src: _unref(getPalletImage)(_ctx.item.featureValues),
            alt: "Imagen del producto"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.item.type == 'seller' && _ctx.item.images.length==0)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "product-img no-photo",
            src: _unref(NoFoto),
            alt: "No hay fotografías"
          }, null, 8, _hoisted_4))
        : (_ctx.item.type == 'seller')
          ? (_openBlock(), _createBlock(ImageSwiperComponent, {
              key: 2,
              images: _ctx.item.images,
              type: "BULLET"
            }, null, 8, ["images"]))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "name",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openUserModal($event)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.item.userName), 1),
          (_ctx.item.certifications?.length>0)
            ? (_openBlock(), _createElementBlock("i", _hoisted_7))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("img", {
          class: "stars",
          src: _unref(getStars)(_ctx.item.rating),
          alt: "Valoración"
        }, null, 8, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.properties, (prop, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(['field', { bold: prop.highlighted,
                                  double: prop.size === 2},
                                  prop.styleMobile.toString().toLowerCase()])
          }, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(prop.label) + ":", 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(prop.value), 1)
          ], 2))
        }), 128))
      ])
    ]),
    _createVNode(ModalComponent, {
      visible: showUserModal.value,
      title: "Información de usuario",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (showUserModal.value=false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("template", null, [
          _createVNode(UserInfo, { userId: _ctx.userId }, null, 8, ["userId"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 2))
}
}

})